import React from "react";
import { Wrapper } from "./cancelled.styles";
import cryFace from "../animatedGifs/tracker-sad-optimised.gif";
import { GradientButton } from "./gradientButton";

export const Cancelled = () => {
  return (
    <Wrapper>
      <img
        className="animated-gif-sad"
        src={cryFace}
        alt="we're sorry to see you go"
      />
      <h3>We’re sorry to see you go!</h3>
      <p>
        You have cancelled your application. If you still need a loan from us,
        please click on the button below to reapply.
      </p>
      <GradientButton
        elementType="a"
        href="/apply"
        className="apply-button"
        buttonText="Reapply Now"
      />
    </Wrapper>
  );
};
